import { createContext, useContext, ReactNode } from 'react';

interface LanguageContextType {
  currentLanguage: string;
  currentMarket: string;
  changeLanguage: (lang: string) => void;
  availableLanguages: Array<{ code: string; name: string; market: string }>;
}

const LanguageContext = createContext<LanguageContextType | undefined>(undefined);

// Hardcoded to Swedish only
const LANGUAGES = [
  { code: 'sv-SE', name: 'Svenska', market: 'SE' },
];

export const LanguageProvider = ({ children }: { children: ReactNode }) => {
  // Always return Swedish
  const currentLanguage = 'sv-SE';
  const currentMarket = 'SE';

  const changeLanguage = (lang: string) => {
    void lang;
  };

  return (
    <LanguageContext.Provider
      value={{
        currentLanguage,
        currentMarket,
        changeLanguage,
        availableLanguages: LANGUAGES,
      }}
    >
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within LanguageProvider');
  }
  return context;
};
